// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l9odU","field":"styles_field__3O1iS","fieldCol":"styles_fieldCol__5sJ9w","diffCol":"styles_diffCol__1e4zT","diff":"styles_diff__2q-iK"};